import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityDepositosState } from './depositos.state';
import { entityDepositosAdapter } from './depositos.state';
import {
  entityDepositosLoadRequest,
  entityDepositosLoadSuccess,
  entityDepositosLoadFailure,
  entityDepositosAddFailure,
  entityDepositosAddRequest,
  entityDepositosAddSuccess,
  entityDepositosDeleteSuccess,
  entityDepositosDeleteRequest,
  entityDepositosDeleteFailure
} from './depositos.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityDepositosLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    hasAddedSuccess: false,
    error: null
  })),
  on(entityDepositosLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityDepositosLoadSuccess, (state, { items }) =>
    entityDepositosAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityDepositosAddRequest, (state) => ({
    ...state,
    isLoading: true,
    hasAddedSuccess: false,
    error: null
  })),
  on(entityDepositosAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityDepositosAddSuccess, (state, { item }) =>
    entityDepositosAdapter.upsertMany(item, {
      ...state,
      isLoading: false,
      hasAddedSuccess: true,
      error: null
    })
  ),
  //delete

  on(entityDepositosDeleteRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),

  on(entityDepositosDeleteFailure, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  })),

  on(entityDepositosDeleteSuccess, (state, { item }) =>
    entityDepositosAdapter.removeOne(item.id, {
      ...state,
      isLoading: false
    })
  )
);

export function depositosReducer(
  state: EntityDepositosState | undefined,
  action: Action
) {
  return reducer(state, action);
}
